import { MenuSearch } from './MenuSearch';

export type TypeMenuSearch = typeof MenuSearch 

export type { TypeMenuSearchProps } from './types';
export default MenuSearch as TypeMenuSearch;
